import {SchoolPin} from "./SchoolPin";
import {getSiteSiteColors} from "@/pages/workspaces/sales/util/siteColors";

/**
 * SchoolMarker component for Google Maps.
 * Renders a custom map marker representing a school site with dynamic styling
 * based on its active state and hover interaction.
 *
 * @param {Object} site - The school site data object containing id, name, and isActive status.
 * @param {string|number|null} hoveredMarkerId - The ID of the marker currently being hovered over in the map context.
 */
export function SchoolMarker({site, hoveredMarkerId}) {

  const {icon, icon_bg} = getSiteSiteColors(site);

  return (
    <div className="flex items-center bg-white rounded-full transition-all duration-200 shadow-md px-2 py-1 ">
      {/* Render the pin icon with color indicating if the site is active (Blue) or inactive (Dark Grey) */}
      <SchoolPin backGround={icon_bg} foreground={icon} site={site}/>

      {/* Expand the marker to show the school name only when this specific marker is hovered */}
      {hoveredMarkerId === site.id && (
        <span className="ml-2 whitespace-nowrap text-xs pr-1"> {site.name} </span>
      )}
    </div>
  )
}
